<!--
 * Bryntum Calendar wrapper for Vue
-->
<template>
  <div class="b-scheduler-container"></div>
</template>

<script>
// Defines a Vue component that wraps Bryntum Scheduler
export default {
  name: "calendar",

  props: {
    // prettier-ignore-start
    // Sections correspond to docs https://bryntum.com/docs/calendar/#Calendar/view/Calendar
    // Configs & Properties joined

    // Configs
    date: Date,
    dateFormat: String,
    eventStore: Object,
    modeDefaults: Object,
    modes: Object,
    readOnly: { type: Boolean, default: undefined },
    sidebar: { type: [Boolean, Object], default: undefined },
    mode: String,

    // Config
    config: Object,

    // CSS
    cls: String,
    htmlCls: String,
    eventColor: String,

    // Common
    listeners: Object,

    // Container
    defaults: Object,
    itemCls: String,
    items: [Object, Array],
    layout: String,
    layoutStyle: Object,
    lazyItems: [Object, Array],
    namedItems: Object,
    record: Object,
    textContent: { type: Boolean, default: undefined },
    values: Object,

    // Data
    assignments: Array,
    assignmentStore: Object,
    calendarManagerStore: Object,
    crudManager: Object,
    crudManagerClass: Function,
    dependencies: Array,
    dependencyStore: Object,
    endParamName: String,
    events: Array,
    passStartEndParameters: { type: Boolean, default: undefined },
    project: Object,
    resources: Array,
    resourceStore: Object,
    resourceTimeRanges: [Object, Array],
    resourceTimeRangeStore: Object,
    startParamName: String,
    taskStore: Object,
    timeRanges: Array,
    timeRangeStore: Object,
    autoCreate: { type: Boolean, default: false },

    // DOM
    content: String,
    dataset: Object,
    html: String,
    owner: Object,
    positioned: { type: Boolean, default: undefined },
    id: String,

    // Layout
    alignSelf: String,
    autoHeight: { type: Boolean, default: undefined },
    fillLastColumn: { type: Boolean, default: undefined },
    fixedRowHeight: { type: Boolean, default: undefined },
    flex: String,
    height: [Number, String],
    margin: [Number, String],
    maxHeight: [Number, String],
    maxWidth: [Number, String],
    minHeight: [Number, String],
    minWidth: [Number, String],
    weight: Number,
    width: [Number, String],

    // Misc
    disabled: { type: Boolean, default: undefined },
    maskDefaults: Object,
    masked: { type: [Boolean, Object, String], default: undefined },
    monitorResize: { type: Boolean, default: undefined },
    preventTooltipOnTouch: { type: Boolean, default: undefined },
    ripple: { type: [Boolean, Object], default: undefined },
    tooltip: [String, Object],

    // Panel
    tbar: { type: [Object, Array], default: undefined },
    bbar: { type: [Object, Array], default: undefined },
    footer: [Object, String],
    header: [Object, String],
    title: [String],
    tools: Object,
    trapFocus: { type: Boolean, default: undefined },

    // Scrolling
    scrollable: { type: [Boolean, Object], default: undefined },

    // Visibility
    hidden: { type: Boolean, default: undefined },

    // Widget
    textAlign: String,

    // Features, only used for initialization
    // These are all features, some may not be usable in resource histogram
    calendarDragFeature: { type: [Boolean, Object], default: undefined },
    calendarDragCreateFeature: { type: [Boolean, Object], default: undefined },
    dragCreateFeature: { type: [Boolean, Object], default: undefined },
    eventEditFeature: { type: [Boolean, Object], default: undefined },
    eventTooltipFeature: { type: [Boolean, Object], default: undefined },
    dragFeature: { type: [Boolean, Object], default: undefined },
    eventMenuFeature: { type: [Boolean, Object], default: undefined }
  },
  // prettier-ignore-end

  // runs after the component is attached to DOM (mounted)
  mounted() {
    const propKeys = Object.keys(this.$props);

    const config = {
      // Render grid to components element
      adopt: this.$el,
      listeners: {},
      features: {}
    };

    // Apply all props to grid config
    propKeys.forEach(prop => {
      let match;
      if ((match = prop.match(/(.*)Feature/)) && this[prop] !== undefined) {
        // Prop which ends with Feature is a feature config
        config.features[match[1]] = this[prop];
      } else if (prop === "config") {
        // Prop is a config object
        Object.assign(config, this[prop]);
      } else {
        // Prop is a config
        if (this[prop] !== undefined) {
          config[prop] = this[prop];
        }

        // Set up a watcher
        this.$watch(prop, newValue => {
          this.calendarInstance[prop] = Array.isArray(newValue)
            ? newValue.slice()
            : newValue;
        });
      }
    }, this);

    // Listeners, will relay events using $emit
    const { listeners } = config;

    listeners.catchAll =
      listeners.catchAll ||
      function(event) {
        // Uncomment this line to log events being emitted
        //console.log(event.type, " :", event);
        this.$emit(event.type, event);
      };
    listeners.thisObj = listeners.thisObj || this;

    // console.log('config=', config, 'props=', this.$props);

    // Create a Bryntum Grid with props as configs
    this.calendarInstance = new window.bryntum.calendar.Calendar(config);
  },

  // cleanup before destroy
  beforeDestroy() {
    // Make sure Bryntum Grid is destroyed when vue component is
    this.calendarInstance.destroy();
  }
};
</script>
